export const sqwTheme = {
  sqwTier2Typography: {
    headingLg: {
      fontWeight: 'var(--sqw-tier2-typography-heading-lg-font-weight)',
      fontSize: 'var(--sqw-tier2-typography-heading-lg-font-size)',
      fontFamily: 'var(--sqw-tier2-typography-heading-lg-font-family)',
      lineHeight: 'var(--sqw-tier2-typography-heading-lg-line-height)',
    },
    bodySm: {
      lineHeight: 'var(--sqw-tier2-typography-body-sm-line-height)',
      fontFamily: 'var(--sqw-tier2-typography-body-sm-font-family)',
      fontWeight: 'var(--sqw-tier2-typography-body-sm-font-weight)',
      fontSize: 'var(--sqw-tier2-typography-body-sm-font-size)',
    },
    bodyMd: {
      lineHeight: 'var(--sqw-tier2-typography-body-md-line-height)',
      fontSize: 'var(--sqw-tier2-typography-body-md-font-size)',
      fontWeight: 'var(--sqw-tier2-typography-body-md-font-weight)',
      fontFamily: 'var(--sqw-tier2-typography-body-md-font-family)',
    },
    labelSmSemibold: {
      fontWeight: 'var(--sqw-tier2-typography-label-sm-semibold-font-weight)',
      lineHeight: 'var(--sqw-tier2-typography-label-sm-semibold-line-height)',
      fontFamily: 'var(--sqw-tier2-typography-label-sm-semibold-font-family)',
      fontSize: 'var(--sqw-tier2-typography-label-sm-semibold-font-size)',
    },
    labelMdSemibold: {
      fontFamily: 'var(--sqw-tier2-typography-label-md-semibold-font-family)',
      fontWeight: 'var(--sqw-tier2-typography-label-md-semibold-font-weight)',
      fontSize: 'var(--sqw-tier2-typography-label-md-semibold-font-size)',
      lineHeight: 'var(--sqw-tier2-typography-label-md-semibold-line-height)',
    },
    title: {
      fontSize: 'var(--sqw-tier2-typography-title-font-size)',
      lineHeight: 'var(--sqw-tier2-typography-title-line-height)',
      fontWeight: 'var(--sqw-tier2-typography-title-font-weight)',
      fontFamily: 'var(--sqw-tier2-typography-title-font-family)',
    },
    labelMd: {
      lineHeight: 'var(--sqw-tier2-typography-label-md-line-height)',
      fontWeight: 'var(--sqw-tier2-typography-label-md-font-weight)',
      fontFamily: 'var(--sqw-tier2-typography-label-md-font-family)',
      fontSize: 'var(--sqw-tier2-typography-label-md-font-size)',
    },
    headingMdSemibold: {
      lineHeight: 'var(--sqw-tier2-typography-heading-md-semibold-line-height)',
      fontFamily: 'var(--sqw-tier2-typography-heading-md-semibold-font-family)',
      fontWeight: 'var(--sqw-tier2-typography-heading-md-semibold-font-weight)',
      fontSize: 'var(--sqw-tier2-typography-heading-md-semibold-font-size)',
    },
    headingMd: {
      fontFamily: 'var(--sqw-tier2-typography-heading-md-font-family)',
      fontSize: 'var(--sqw-tier2-typography-heading-md-font-size)',
      fontWeight: 'var(--sqw-tier2-typography-heading-md-font-weight)',
      lineHeight: 'var(--sqw-tier2-typography-heading-md-line-height)',
    },
    navHeader: {
      fontFamily: 'var(--sqw-tier2-typography-nav-header-font-family)',
      fontWeight: 'var(--sqw-tier2-typography-nav-header-font-weight)',
      fontSize: 'var(--sqw-tier2-typography-nav-header-font-size)',
      lineHeight: 'var(--sqw-tier2-typography-nav-header-line-height)',
    },
    link: {
      fontFamily: 'var(--sqw-tier2-typography-link-font-family)',
      fontWeight: 'var(--sqw-tier2-typography-link-font-weight)',
      fontSize: 'var(--sqw-tier2-typography-link-font-size)',
      lineHeight: 'var(--sqw-tier2-typography-link-line-height)',
    },
    display: {
      fontFamily: 'var(--sqw-tier2-typography-display-font-family)',
      fontWeight: 'var(--sqw-tier2-typography-display-font-weight)',
      fontSize: 'var(--sqw-tier2-typography-display-font-size)',
      lineHeight: 'var(--sqw-tier2-typography-display-line-height)',
    },
  },
  sqwTier1: {
    color: {
      focusBlue: {
        '10': 'var(--sqw-tier1-color-focus-blue-10)',
        '20': 'var(--sqw-tier1-color-focus-blue-20)',
      },
      infoBlue: {
        '10': 'var(--sqw-tier1-color-info-blue-10)',
        '20': 'var(--sqw-tier1-color-info-blue-20)',
        '30': 'var(--sqw-tier1-color-info-blue-30)',
        '40': 'var(--sqw-tier1-color-info-blue-40)',
        '50': 'var(--sqw-tier1-color-info-blue-50)',
      },
      seaweed: {
        '10': 'var(--sqw-tier1-color-seaweed-10)',
        '20': 'var(--sqw-tier1-color-seaweed-20)',
        '30': 'var(--sqw-tier1-color-seaweed-30)',
        '40': 'var(--sqw-tier1-color-seaweed-40)',
        '50': 'var(--sqw-tier1-color-seaweed-50)',
      },
      mango: {
        '10': 'var(--sqw-tier1-color-mango-10)',
        '20': 'var(--sqw-tier1-color-mango-20)',
        '30': 'var(--sqw-tier1-color-mango-30)',
        '40': 'var(--sqw-tier1-color-mango-40)',
        '50': 'var(--sqw-tier1-color-mango-50)',
      },
      chili: {
        '10': 'var(--sqw-tier1-color-chili-10)',
        '20': 'var(--sqw-tier1-color-chili-20)',
        '30': 'var(--sqw-tier1-color-chili-30)',
        '40': 'var(--sqw-tier1-color-chili-40)',
        '50': 'var(--sqw-tier1-color-chili-50)',
      },
      transparency: {
        '0': 'var(--sqw-tier1-color-transparency-0)',
        balticSea: {
          '70-30': 'var(--sqw-tier1-color-transparency-baltic-sea-7030)',
          '80-50': 'var(--sqw-tier1-color-transparency-baltic-sea-8050)',
          '100-50': 'var(--sqw-tier1-color-transparency-baltic-sea-10050)',
        },
      },
      indigo: {
        '10': 'var(--sqw-tier1-color-indigo-10)',
        '20': 'var(--sqw-tier1-color-indigo-20)',
        '30': 'var(--sqw-tier1-color-indigo-30)',
        '40': 'var(--sqw-tier1-color-indigo-40)',
        '50': 'var(--sqw-tier1-color-indigo-50)',
        '60': 'var(--sqw-tier1-color-indigo-60)',
        '70': 'var(--sqw-tier1-color-indigo-70)',
        '80': 'var(--sqw-tier1-color-indigo-80)',
        '90': 'var(--sqw-tier1-color-indigo-90)',
        '100': 'var(--sqw-tier1-color-indigo-100)',
      },
      balticSea: {
        '10': 'var(--sqw-tier1-color-baltic-sea-10)',
        '20': 'var(--sqw-tier1-color-baltic-sea-20)',
        '30': 'var(--sqw-tier1-color-baltic-sea-30)',
        '40': 'var(--sqw-tier1-color-baltic-sea-40)',
        '50': 'var(--sqw-tier1-color-baltic-sea-50)',
        '60': 'var(--sqw-tier1-color-baltic-sea-60)',
        '70': 'var(--sqw-tier1-color-baltic-sea-70)',
        '80': 'var(--sqw-tier1-color-baltic-sea-80)',
        '90': 'var(--sqw-tier1-color-baltic-sea-90)',
        '100': 'var(--sqw-tier1-color-baltic-sea-100)',
      },
      black: 'var(--sqw-tier1-color-black)',
      white: 'var(--sqw-tier1-color-white)',
    },
    typography: {
      fontSize: {
        '12': 'var(--sqw-tier1-typography-font-size-12)',
        '14': 'var(--sqw-tier1-typography-font-size-14)',
        '16': 'var(--sqw-tier1-typography-font-size-16)',
        '22': 'var(--sqw-tier1-typography-font-size-22)',
        '30': 'var(--sqw-tier1-typography-font-size-30)',
        '44': 'var(--sqw-tier1-typography-font-size-44)',
      },
      fontWeight: {
        semibold: 'var(--sqw-tier1-typography-font-weight-semibold)',
        regular: 'var(--sqw-tier1-typography-font-weight-regular)',
        medium: 'var(--sqw-tier1-typography-font-weight-medium)',
      },
      lineHeight: {
        '16': 'var(--sqw-tier1-typography-line-height-16)',
        '20': 'var(--sqw-tier1-typography-line-height-20)',
        '24': 'var(--sqw-tier1-typography-line-height-24)',
        '28': 'var(--sqw-tier1-typography-line-height-28)',
        '40': 'var(--sqw-tier1-typography-line-height-40)',
        '54': 'var(--sqw-tier1-typography-line-height-54)',
      },
      fontFamily: {
        inter: 'var(--sqw-tier1-typography-font-family-inter)',
      },
    },
  },
  sqwTier2Color: {
    background: {
      nav: {
        default: 'var(--sqw-tier2-color-background-nav-default)',
        selected: 'var(--sqw-tier2-color-background-nav-selected)',
        hovered: 'var(--sqw-tier2-color-background-nav-hovered)',
      },
      error: {
        bold: {
          pressed: 'var(--sqw-tier2-color-background-error-bold-pressed)',
          default: 'var(--sqw-tier2-color-background-error-bold-default)',
          hovered: 'var(--sqw-tier2-color-background-error-bold-hovered)',
        },
        subtle: 'var(--sqw-tier2-color-background-error-subtle)',
      },
      input: 'var(--sqw-tier2-color-background-input)',
      neutral: {
        subtlest: {
          default: 'var(--sqw-tier2-color-background-neutral-subtlest-default)',
          hovered: 'var(--sqw-tier2-color-background-neutral-subtlest-hovered)',
          selected: 'var(--sqw-tier2-color-background-neutral-subtlest-selected)',
        },
        subtle: {
          hovered: 'var(--sqw-tier2-color-background-neutral-subtle-hovered)',
          default: 'var(--sqw-tier2-color-background-neutral-subtle-default)',
          selected: 'var(--sqw-tier2-color-background-neutral-subtle-selected)',
        },
        bold: 'var(--sqw-tier2-color-background-neutral-bold)',
      },
      success: {
        bold: {
          default: 'var(--sqw-tier2-color-background-success-bold-default)',
          hovered: 'var(--sqw-tier2-color-background-success-bold-hovered)',
          pressed: 'var(--sqw-tier2-color-background-success-bold-pressed)',
        },
        subtle: 'var(--sqw-tier2-color-background-success-subtle)',
      },
      disabled: {
        default: 'var(--sqw-tier2-color-background-disabled-default)',
        subtle: 'var(--sqw-tier2-color-background-disabled-subtle)',
      },
      brand: {
        bold: {
          default: 'var(--sqw-tier2-color-background-brand-bold-default)',
          hovered: 'var(--sqw-tier2-color-background-brand-bold-hovered)',
          pressed: 'var(--sqw-tier2-color-background-brand-bold-pressed)',
        },
        subtle: {
          default: 'var(--sqw-tier2-color-background-brand-subtle-default)',
          pressed: 'var(--sqw-tier2-color-background-brand-subtle-pressed)',
          hovered: 'var(--sqw-tier2-color-background-brand-subtle-hovered)',
        },
      },
      info: {
        bold: {
          default: 'var(--sqw-tier2-color-background-info-bold-default)',
          hovered: 'var(--sqw-tier2-color-background-info-bold-hovered)',
          pressed: 'var(--sqw-tier2-color-background-info-bold-pressed)',
        },
        subtle: 'var(--sqw-tier2-color-background-info-subtle)',
      },
      warning: {
        subtle: 'var(--sqw-tier2-color-background-warning-subtle)',
        bold: {
          default: 'var(--sqw-tier2-color-background-warning-bold-default)',
          hovered: 'var(--sqw-tier2-color-background-warning-bold-hovered)',
          pressed: 'var(--sqw-tier2-color-background-warning-bold-pressed)',
        },
      },
    },
    text: {
      brand: {
        default: 'var(--sqw-tier2-color-text-brand-default)',
        visited: 'var(--sqw-tier2-color-text-brand-visited)',
        hovered: 'var(--sqw-tier2-color-text-brand-hovered)',
        pressed: 'var(--sqw-tier2-color-text-brand-pressed)',
      },
      selected: 'var(--sqw-tier2-color-text-selected)',
      inverse: 'var(--sqw-tier2-color-text-inverse)',
      warningInverse: 'var(--sqw-tier2-color-text-warning-inverse)',
      info: {
        onSubtle: 'var(--sqw-tier2-color-text-info-on-subtle)',
        default: 'var(--sqw-tier2-color-text-info-default)',
      },
      subtle: 'var(--sqw-tier2-color-text-subtle)',
      disabled: 'var(--sqw-tier2-color-text-disabled)',
      warning: {
        onSubtle: 'var(--sqw-tier2-color-text-warning-on-subtle)',
        default: 'var(--sqw-tier2-color-text-warning-default)',
      },
      subtlest: 'var(--sqw-tier2-color-text-subtlest)',
      error: {
        onSubtle: 'var(--sqw-tier2-color-text-error-on-subtle)',
        default: 'var(--sqw-tier2-color-text-error-default)',
      },
      success: {
        default: 'var(--sqw-tier2-color-text-success-default)',
        onSubtle: 'var(--sqw-tier2-color-text-success-on-subtle)',
      },
      default: 'var(--sqw-tier2-color-text-default)',
    },
    surface: {
      sunken: 'var(--sqw-tier2-color-surface-sunken)',
      elevation: {
        shadow: 'var(--sqw-tier2-color-surface-elevation-shadow)',
        blanket: 'var(--sqw-tier2-color-surface-elevation-blanket)',
      },
      raised: 'var(--sqw-tier2-color-surface-raised)',
      structure: 'var(--sqw-tier2-color-surface-structure)',
    },
    border: {
      brand: {
        hovered: 'var(--sqw-tier2-color-border-brand-hovered)',
        default: 'var(--sqw-tier2-color-border-brand-default)',
        pressed: 'var(--sqw-tier2-color-border-brand-pressed)',
      },
      disabled: 'var(--sqw-tier2-color-border-disabled)',
      warning: 'var(--sqw-tier2-color-border-warning)',
      bold: 'var(--sqw-tier2-color-border-bold)',
      subtle: 'var(--sqw-tier2-color-border-subtle)',
      input: 'var(--sqw-tier2-color-border-input)',
      error: 'var(--sqw-tier2-color-border-error)',
      info: 'var(--sqw-tier2-color-border-info)',
      focus: 'var(--sqw-tier2-color-border-focus)',
      selected: 'var(--sqw-tier2-color-border-selected)',
      success: 'var(--sqw-tier2-color-border-success)',
      nav: {
        bold: 'var(--sqw-tier2-color-border-nav-bold)',
        subtle: 'var(--sqw-tier2-color-border-nav-subtle)',
      },
    },
    skeleton: {
      shimmer: 'var(--sqw-tier2-color-skeleton-shimmer)',
      default: 'var(--sqw-tier2-color-skeleton-default)',
    },
    icon: {
      default: 'var(--sqw-tier2-color-icon-default)',
      subtle: 'var(--sqw-tier2-color-icon-subtle)',
      subtlest: 'var(--sqw-tier2-color-icon-subtlest)',
      inverse: 'var(--sqw-tier2-color-icon-inverse)',
      warningInverse: 'var(--sqw-tier2-color-icon-warning-inverse)',
      selected: 'var(--sqw-tier2-color-icon-selected)',
      brand: {
        default: 'var(--sqw-tier2-color-icon-brand-default)',
        hovered: 'var(--sqw-tier2-color-icon-brand-hovered)',
        pressed: 'var(--sqw-tier2-color-icon-brand-pressed)',
        visited: 'var(--sqw-tier2-color-icon-brand-visited)',
      },
      disabled: 'var(--sqw-tier2-color-icon-disabled)',
      error: {
        default: 'var(--sqw-tier2-color-icon-error-default)',
        onSubtle: 'var(--sqw-tier2-color-icon-error-on-subtle)',
      },
      warning: {
        default: 'var(--sqw-tier2-color-icon-warning-default)',
        onSubtle: 'var(--sqw-tier2-color-icon-warning-on-subtle)',
      },
      success: {
        default: 'var(--sqw-tier2-color-icon-success-default)',
        onSubtle: 'var(--sqw-tier2-color-icon-success-on-subtle)',
      },
      info: {
        default: 'var(--sqw-tier2-color-icon-info-default)',
        onSubtle: 'var(--sqw-tier2-color-icon-info-on-subtle)',
      },
    },
  },
};
